import { store } from 'store';
import { MasterDocumentTypeConstants } from './keyConstants';

// Utility to get master document data by name
export const getMasterDoc = (documentName, moduleType = 'format') => {
  const { documents = [] } = store.getState()?.data?.masterData || {};
  return documents.find(
    (doc) => doc?.defaultName === documentName && doc.moduleType === moduleType
  );
};

export const getMasterDocDataByKey = (
  searchParams = {}, // { defaultName?: string, masterDocId?: string }
  type = MasterDocumentTypeConstants.FORMAT
) => {
  const documents = store
    ?.getState?.()
    ?.data?.masterData?.documents ?? [];

  // Prioritize: defaultName → masterDocId
  const { defaultName, masterDocId } = searchParams || {};

  if (defaultName) {
    return documents?.find(
      (doc) =>
        doc?.defaultName === defaultName &&
        doc?.moduleType === type
    );
  }

  if (masterDocId) {
    return documents?.find(
      (doc) =>
        doc?.masterDocId === masterDocId &&
        doc?.moduleType === type
    );
  }

  return null;
};


// Utility to get permission object for a specific document
export const getPermission = (documentName, type) => {
  console.log('documentName', documentName);
  const { permissions = [] } = store.getState()?.data?.masterData || {};
  return (
    permissions.find(
      (p) => p?.defaultName === documentName && p?.moduleType === type
    )?.permission || {}
  );
};

// Utility to check specific permission type for a document
export const checkUpdatedPermission = (permission, documentName, type = MasterDocumentTypeConstants.RECORD) => {
  const { permissions = [] } = store.getState()?.data?.masterData || {};
  const docPerm =
    permissions.find(
      (p) => p?.defaultName === documentName && p?.moduleType === type
    )?.permission || {};
  return docPerm[permission] === true;
};

// Utility to check only read permission of a document
export const checkIsReadOnly = (documentName, type) => {
  const { permissions = [] } = store.getState()?.data?.masterData || {};
  const docPerm =
    permissions.find(
      (p) => p?.defaultName === documentName && p?.moduleType === type
    )?.permission || {};
  const hasRead =
    Object.keys(docPerm).length === 0 ||
    (docPerm.read === true &&
      docPerm.create === false &&
      docPerm.update === false &&
      docPerm.delete === false);
  return hasRead;
};


/**
 * Utility to get static header data from Redux store
 * @returns {object} - Header data object (could be {} if not loaded)
 */
export const getHeaderData = () => {
  const state = store.getState();
  return state?.layout?.header?.data || {};
};